// Models
import { FixedDate } from "./FixedDate";
/**
 * Represents a monthly fixed date.
 * @example 15th of a month.
 */ export class MonthlyFixedDate extends FixedDate {
    getMonthForPeriod(period) {
        return period.month;
    }
}
